var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProperty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 7.58887L9.5 33.0467V91.3123H84.5V33.0467L47 7.58887Z",
    fill: "#EFD1B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 60.0625H40.75V91.3125H23.5625V60.0625Z",
    fill: "#D7AE88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9375 74.125H79.8125V80.375H57.9375V74.125Z",
    fill: "#2C3A64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 91.3125V69.4375L56.375 64.75L59.5 69.4375V91.3125H53.25Z",
    fill: "#4B81AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.75 91.3125V69.4375L68.875 64.75L72 69.4375V91.3125H65.75Z",
    fill: "#4B81AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.25 91.3125V69.4375L81.375 64.75L84.5 69.4375V91.3125H78.25Z",
    fill: "#4B81AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6875 46H42.3125C39.7234 46 37.625 43.9016 37.625 41.3125V31.9375C37.625 29.3484 39.7234 27.25 42.3125 27.25H51.6875C54.2766 27.25 56.375 29.3484 56.375 31.9375V41.3125C56.375 43.9016 54.2766 46 51.6875 46Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.375 35.0625H48.5625V27.25H45.4375V35.0625H37.625V38.1875H45.4375V46H48.5625V38.1875H56.375V35.0625Z",
    fill: "#B0D2EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9375 74.125H36.0625V77.25H32.9375V74.125Z",
    fill: "#2C3A64"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9375 78.8125H11.0625V91.3125H7.9375V78.8125Z",
    fill: "#2A5B43"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3125 72.5621C17.3125 78.1715 13.8141 81.9371 9.5 81.9371C5.18594 81.9371 1.6875 78.1715 1.6875 72.5621C1.6875 68.8996 5.01719 60.0309 7.32969 54.3137C8.12031 52.359 10.8813 52.359 11.6719 54.3137C13.9828 60.0309 17.3125 68.8996 17.3125 72.5621Z",
    fill: "#3A8761"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 89.75C0.125 88.6454 1.02043 87.75 2.125 87.75H91.875C92.9796 87.75 93.875 88.6454 93.875 89.75V91.68C93.875 92.7846 92.9796 93.68 91.875 93.68H2.125C1.02043 93.68 0.125 92.7846 0.125 91.68V89.75Z",
    fill: "#031C2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1182 34.4311C89.498 35.3452 88.2543 35.5833 87.3402 34.9631L48.1229 8.3513C47.4449 7.89124 46.5549 7.89124 45.8769 8.3513L6.65957 34.9631C5.74555 35.5833 4.50181 35.3452 3.8816 34.4311L2.61818 32.5692C1.99798 31.6552 2.23615 30.4115 3.15015 29.7913L45.8769 0.798172C46.5549 0.338109 47.4449 0.33811 48.1229 0.798173L90.8497 29.7913C91.7637 30.4115 92.0018 31.6552 91.3816 32.5692L90.1182 34.4311Z",
    fill: "#2A5B43"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProperty);
export default __webpack_public_path__ + "static/media/imgProperty.1d57e8772b087392aa69ed1b908fb724.svg";
export { ForwardRef as ReactComponent };